// extracted by mini-css-extract-plugin
module.exports = {"block":"get-started-module--block--c9pRK","heading":"get-started-module--heading--3eRd5","icon":"get-started-module--icon--1ibKR","intro":"get-started-module--intro--rknrK"};